export const tableColumns = [
  "PNR Number",
  "Train Name",
  "Customer Name",
  "Mobile Number",
  "Journey Date",
  "Ticket Status",
  "Actions",
];
